import { render, staticRenderFns } from "./LandingPageEditorCoverEditor.vue?vue&type=template&id=5039cd1b"
import script from "./LandingPageEditorCoverEditor.vue?vue&type=script&lang=js"
export * from "./LandingPageEditorCoverEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports